import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber, injectIntl } from 'react-intl';
import { withRouter } from 'utils/withRouter';
import { Row, Col } from 'antd';
import { Div, FormItem, FormText, Icon } from 'ui';
import SidePanel from 'common/side-panel/side-panel';
import HandlingUnit from './handling-unit';

const DetailsItem = styled(FormItem)`
  .ant-legacy-form-item-label {
    line-height: 25px;

    label {
      color: ${p => p.theme.colors.textLight};
    }
  }
  .ant-legacy-form-item-control {
    line-height: 25px;
  }
`;

const StyledIcon = styled(Icon)`
  font-size: 15px;
  margin-right: 5px;
  --fa-secondary-color: #7e7e7e;
  --fa-primary-color: #6bc93c;
  --fa-secondary-opacity: 1;
  color: #7e7e7e;
`;

const PartDetails = ({ part, onClose, history, intl }) => {
  if (!part) {
    return null;
  }

  const gotoDetails = () => {
    history.back();
    onClose();
  };

  return (
    <SidePanel
      width={'40%'}
      title={intl.formatMessage({ id: 'common.titles.PART_DETAILS' })}
      onPanelClose={gotoDetails}
    >
      <Div paddingLeft={5}>
        <Row>
          <Col span={12}>
            <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.MATERIAL' })}>
              <FormText>{part?.materialNumber}</FormText>
            </DetailsItem>
          </Col>
          <Col span={12}>
            <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.DESCRIPTION' })}>
              <FormText>{part?.materialDescription}</FormText>
            </DetailsItem>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.QUANTITY_ORDERED' })}>
              <FormText>
                <FormattedNumber value={part?.quantityOrdered} /> {part?.quantityOrderedUnit}
              </FormText>
            </DetailsItem>
          </Col>
          <Col span={12}>
            <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.COST' })}>
              <FormText>
                {Number.isFinite(part?.cost) ?
                  intl.formatNumber(part?.cost, {
                    style: 'currency', //eslint-disable-line
                    currency: part.costCurrency || 'XXX',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }).replace('XXX', '')
                  : null}
              </FormText>
            </DetailsItem>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.WEIGHT' })}>
              <FormText>
                <FormattedNumber value={part?.weight} /> {part?.weightUnit}
              </FormText>
            </DetailsItem>
          </Col>
          <Col span={12}>
            <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.VENDOR' })}>
              <FormText>{part?.vendorName}</FormText>
            </DetailsItem>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.FLOW' })}>
              <FormText>{part?.logisticFlow}</FormText>
            </DetailsItem>
          </Col>
          <Col span={12}>
            <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.LOGISTICS_PLANT' })}>
              <FormText>{part?.plant}</FormText>
            </DetailsItem>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.PO_NUMBER' })}>
              <FormText>{part?.poNumber}</FormText>
            </DetailsItem>
          </Col>
          <Col span={12}>
            <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.PO_TYPE' })}>
              <FormText>{part?.poType}</FormText>
            </DetailsItem>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <DetailsItem
              label={intl.formatMessage({ id: 'order.parts.labels.LOGISTICS_SHIPPING_DATE' })}
            >
              <Div>
                <StyledIcon className={part?.shippingDate?.icon} />
                {part?.shippingDate?.fullDescription}
              </Div>
            </DetailsItem>
          </Col>
          <Col span={12}>
            <DetailsItem
              label={intl.formatMessage({ id: 'order.parts.labels.LOGISTICS_DELIVERY_DATE' })}
            >
              <Div>
                <StyledIcon className={part?.deliveryDate?.icon} />
                {part?.deliveryDate?.fullDescription}
              </Div>
            </DetailsItem>
          </Col>
        </Row>
        <HandlingUnit logisticsDetails={part?.logisticsDetails} />
      </Div >
    </SidePanel >
  );
};
PartDetails.propTypes = {
  part: PropTypes.object,
  onClose: PropTypes.func,
  history: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(withRouter(PartDetails));
